// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import '../../styles/containers/Party.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { FormControl, Checkbox } from 'react-bootstrap';
import DatePicker from '../utils/FormWidgets/DatePicker';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import Error from '../stateMessage/Error';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import SearchLocationForm from './SearchLocationForm';
import { PARTIES_CSV_HEADERS } from '../../infrastructure/constants/parties';
import CSVLinkButton from '../utils/CSVLinkButton';
import QuickOrdersFilters from '../utils/QuickFilters';
import {
  StyledFilterCheckbox,
  StyledFilterDateField,
  StyledFilterFormGroup,
  StyledFilterTitle,
  StyledFilterWrapper,
} from '../utils/Styles/FilterStyles';
import { FilterPanel } from '../utils/FilterPanel';

const filteredDataInitial = {
  name: '',
  location: '',
  from: '',
  to: '',
  inviteCode: '',
  partyStatus: 'all',
  partyType: 'all',
};

const initialState = {
  filteredData: filteredDataInitial,
  isSuccsess: false,
  locationText: '',
  virtual: '',
  isError: false,
  isDeactive: false,
};

export const PARTY_TYPES = [
  { label: 'All', name: 'all' },
  { label: 'Bachelorette', name: 'bachelorette' },
  { label: 'Bachelor', name: 'bachelor' },
  { label: 'Birthday', name: 'birthday' },
  { label: 'Anniversary', name: 'anniversary' },
  { label: 'Baby Shower', name: 'baby-shower' },
  { label: 'Bridal Shower', name: 'bridal-shower' },
  { label: 'Company Event', name: 'company-event' },
  { label: 'Costume', name: 'costume' },
  { label: 'Dinner Party', name: 'dinner-party' },
  { label: 'Divorce', name: 'divorce' },
  { label: "Dog's Birthday", name: 'dog-birthday' },
  { label: 'Engagement', name: 'engagement' },
  { label: 'Friendsgiving', name: 'friendsgiving' },
  { label: 'Girls trip', name: 'girls-trip' },
  { label: 'Graduation', name: 'graduation' },
  { label: 'Group trip', name: 'group-trip' },
  { label: 'Guys trip', name: 'guys-trip' },
  { label: 'Halloween', name: 'halloween' },
  { label: 'Holiday', name: 'holiday' },
  { label: 'Housewarming', name: 'housewarming' },
  { label: 'Just a Good Time', name: 'good-time' },
  { label: 'Reunion', name: 'reunion' },
  { label: 'Watch Party', name: 'watch-party' },
  { label: 'Other', name: 'other' },
];

export default class PartiesFilterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterData } = this.props;
    if (filterData) {
      this.setState({
        filteredData: filterData,
        locationText:
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          filterData.location === 'Virtual BACH Party'
            ? '' // TODO: Fix this the next time the file is edited.
            : // eslint-disable-next-line react/prop-types
              filterData.location,
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        virtual: filterData.location === 'Virtual BACH Party',
      });
    }
  }

  componentWillUnmount() {
    this.setState({ isDeactive: true });
  }

  handleNameChange = ({ target }) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      name: target.value,
    };
    this.setState({ filteredData });
    if (target.value.length >= 3 || target.value.length === 0) {
      this.handleSubmit(filteredData);
    }
  };

  handleInviteCodeChange = ({ target }) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      inviteCode: target.value.toUpperCase(),
    };
    this.setState({ filteredData });
    if (target.value.length >= 3 || target.value.length === 0) {
      this.handleSubmit(filteredData);
    }
  };

  handleFromDateChange = date => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    let { filteredData } = this.state;
    let d = date;
    if (date === undefined) {
      d = '';
    }
    filteredData = {
      ...filteredData,
      from: d,
    };
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  changeLocationText = text => {
    this.setState({ locationText: text });
  };

  handleToDateChange = date => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    let { filteredData } = this.state;
    let d = date;
    if (d === undefined) {
      d = '';
    }
    filteredData = {
      ...filteredData,
      to: d,
    };
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  hideMessage = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { isDeactive } = this.state;
    if (!isDeactive) {
      this.setState({ isError: false });
    }
  };

  locationChanged = location => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      location,
    };
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  changeVirtualStatus = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { filteredData, virtual } = this.state;
    const newFilteredData = {
      ...filteredData,
      location: virtual ? '' : 'Virtual BACH Party',
    };
    this.setState({ filteredData: newFilteredData, virtual: !virtual });
    this.handleSubmit(newFilteredData);
  };

  onStatusChange = val => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { filteredData } = this.state;
    const newFilteredData = {
      ...filteredData,
      partyStatus: val,
    };
    this.setState({ filteredData: newFilteredData });
    this.handleSubmit(newFilteredData);
  };

  onPartyTypeChange = val => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { filteredData } = this.state;
    const newFilteredData = {
      ...filteredData,
      partyType: val,
    };
    this.setState({ filteredData: newFilteredData });
    this.handleSubmit(newFilteredData);
  };

  handleSubmit = async filteredData => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterParties } = this.props;
    const copyFilterParties = { ...filteredData };

    if (copyFilterParties.partyStatus === 'all') {
      copyFilterParties.partyStatus = '';
    }

    if (copyFilterParties.partyType === 'all') {
      copyFilterParties.partyType = '';
    }

    filterParties(copyFilterParties);
  };

  clear = () => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { clear } = this.props;
    this.setState({
      filteredData: filteredDataInitial,
      locationText: '',
      virtual: false,
    });
    clear();
  };

  onQuickFilterClick = (filter, sort) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { applyQuickFilter } = this.props;
    const { key, value } = filter;
    const newFilter = {
      ...filteredDataInitial,
      [key]: value,
    };
    this.setState({ filteredData: newFilter });
    applyQuickFilter(newFilter, sort);
  };

  render() {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { filteredData, locationText, virtual, isError } = this.state;
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      filterData,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      isMobileFilterSelected,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      csvParties,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      loadCSVParties,
    } = this.props;

    return (
      <Fragment>
        {isError && <Error text='server error' />}

        <div
          className={`form-content horizontal-form filter-form ${
            isMobileFilterSelected ? 'mobile-filter-selected' : ''
          }`}
          style={{ paddingLeft: '0px' }}
        >
          <StyledFilterTitle>Filters</StyledFilterTitle>
          <StyledFilterWrapper>
            <StyledFilterFormGroup>
              <FormControl
                type='text'
                placeholder='Name (3 characters min)'
                onChange={this.handleNameChange}
                value={filteredData.name}
              />
            </StyledFilterFormGroup>
            <SearchLocationForm
              search={this.locationChanged}
              disabled={virtual}
              value={locationText}
              textChange={this.changeLocationText}
            />
            <StyledFilterFormGroup
              style={{
                width: '210px',
                display: 'inline-block',
              }}
            >
              <FormControl
                type='text'
                placeholder='Invite Code'
                onChange={this.handleInviteCodeChange}
                value={filteredData.inviteCode}
              />
            </StyledFilterFormGroup>

            <StyledFilterCheckbox controlId='bookable'>
              <Checkbox
                inline
                onClick={this.changeVirtualStatus}
                disabled={locationText.length > 0}
                checked={virtual}
              >
                <span style={{ fontSize: '18px' }}>Virtual BACH Party</span>
              </Checkbox>
            </StyledFilterCheckbox>
          </StyledFilterWrapper>
          <StyledFilterWrapper>
            <FilterPanel
              filters={[
                { label: 'All', name: 'all' },
                { label: 'Pending', name: 'pending' },
                { label: 'Deactivated ', name: 'deactivated' },
              ]}
              currentFilter={filteredData.partyStatus}
              onFilterChange={this.onStatusChange}
            />

            <FilterPanel
              filters={PARTY_TYPES}
              currentFilter={filteredData.partyType}
              onFilterChange={this.onPartyTypeChange}
            />

            <StyledFilterDateField>
              <div
                style={{
                  display: 'inline-block',
                  verticalAlign: 'top',
                  marginRight: '12px',
                  fontSize: '18px',
                }}
              >
                From
              </div>
              <StyledFilterFormGroup
                style={{
                  paddingLeft: '0px',
                  width: '175px',
                  display: 'inline-block',
                  marginRight: '20px',
                }}
              >
                <DatePicker
                  value={filteredData.from}
                  handleChange={this.handleFromDateChange}
                />
              </StyledFilterFormGroup>
            </StyledFilterDateField>

            <StyledFilterDateField>
              <div
                style={{
                  display: 'inline-block',
                  fontSize: '18px',
                  marginRight: '12px',
                }}
              >
                To
              </div>
              <StyledFilterFormGroup
                style={{
                  paddingLeft: '0px',
                  width: '175px',
                  display: 'inline-block',
                  marginRight: '20px',
                }}
              >
                <DatePicker
                  value={filteredData.to}
                  handleChange={this.handleToDateChange}
                />
              </StyledFilterFormGroup>
            </StyledFilterDateField>
          </StyledFilterWrapper>

          <StyledFilterWrapper>
            <QuickOrdersFilters
              filters={[
                {
                  text: 'Upcoming Parties',
                  filter: {
                    key: 'from',
                    value: new Date(new Date().setHours(0, 0, 0, 0)),
                  },
                  sort: 'startDate',
                },
              ]}
              onQuickFilterClick={this.onQuickFilterClick}
            />

            <div>
              <button
                type='button'
                onClick={this.clear}
                className='btn btn-def'
                style={{ width: '114px', marginLeft: '58px' }}
              >
                Clear all
              </button>
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <CSVLinkButton
                  style={{ marginTop: 0 }}
                  data={[
                    {
                      id: 1,
                      items: csvParties,
                      headers: PARTIES_CSV_HEADERS,
                      fileName: 'parties.csv',
                    },
                  ]}
                  filterData={filterData}
                  loadData={loadCSVParties}
                />
              }
            </div>
          </StyledFilterWrapper>
        </div>
      </Fragment>
    );
  }
}
